var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"font-weight-bold caption",class:_vm.timerClass},[_c('v-icon',{staticClass:"mr-1",attrs:{"x-small":"","color":_vm.timerColor}},[_vm._v("mdi-timer")]),_vm._v(" "+_vm._s(_vm.displayTime)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }